module.exports = __webpack_public_path__ + "img/Thailand-hover.ce72491b.jpg";